module.exports = __webpack_public_path__ + "img/reid-college-logo.8bbaf04f.jpg";